import { useAttendeeHubConfig } from '@hooks/useAttendeeHubConfig';
import { ApolloError } from '@apollo/client';

interface CanShowCommunityPageResult {
  data?: boolean;
  loading: boolean;
  error?: ApolloError;
}

/**
 * Returns if the community page can be shown based on the state of
 * dependant features and feature flags.
 * @returns {data : boolean, loading: boolean, error: unknown}
 * @abstract Please refer to the following wiki page for visibility matrix
 *           https://wiki.cvent.com/display/AH/Community+Page+-+Navigation+Matrix
 */
export const useCanShowCommunityPage = (): CanShowCommunityPageResult => {
  const { isFeatureSettingEnabled, loading: loadingConfig, error } = useAttendeeHubConfig();
  if (loadingConfig) {
    return { loading: true };
  }

  const canShowPage = isFeatureSettingEnabled('ATTENDEE_LIST') && isFeatureSettingEnabled('VIDEO_DISCUSSIONS');
  return { data: canShowPage, loading: false, error };
};

export default useCanShowCommunityPage;
